import React from 'react';
import { Helmet } from 'react-helmet';
import { useQuery } from '@apollo/react-hooks';
import { Redirect, useParams, useLocation } from 'react-router-dom';
import { reduceContent, parseSearch } from '../globalUtils';
import { CONTENT_BY_PAGE, BOT_BY_NAME } from '../../graphql';
import { BotContainer } from './index.style';
import { Bot1 } from './Bot1';
import { Bot2 } from './Bot2';
import { BotGeneric } from './BotGeneric';
import { Loader } from '../Generic';
const { REACT_APP_SERVER_URI: serverUri } = process.env;

const RenderBot = ({ bot, reducedContent }) => {
    const { innerName, name, code, source, sourceName, lead, image, content_0, content_1 } = bot;
    const { bot1, bot2 } = reducedContent;
    const { search } = useLocation();
    const { l: leadOverride, s: sourceOverride } = parseSearch(search);

    switch (innerName) {
        case 'bot1':
            return <Bot1
                code={code}
                source={sourceOverride || source}
                lead={leadOverride || lead}
                content={bot1.contentEdit}
            />;
        case 'bot2':
            return <Bot2
                code={code}
                source={sourceOverride || source}
                lead={leadOverride || lead}
                content={bot2.contentEdit}
            />;
        default:
            return <BotGeneric
                code={code}
                name={name}
                source={sourceOverride || source}
                sourceName={leadOverride || sourceName}
                lead={lead}
                image={image}
                content_0={content_0}
                content_1={content_1}
            />
    }
};

const Bot = () => {
    const { name } = useParams();
    const { loading: l1, error: e1, data: d1 } = useQuery(CONTENT_BY_PAGE, {
        variables: {
            page: 'bots',
            language: 'he',
        },
    });
    const { loading: l2, error: e2, data: d2 } = useQuery(BOT_BY_NAME, {
        variables: { name }
    });
    if (l1 || l2) {
        return <BotContainer>
            <Loader />
        </BotContainer>;
    }
    if (e1 || e2) {
        return <BotContainer>קרתה שגיאה</BotContainer>;
    }

    const { contentByPage } = d1;
    const { botByName } = d2;
    const reducedContent = reduceContent(contentByPage);

    const { head } = reducedContent;
    const { title, meta: { description: metaDescription, title: metaTitle, image: metaImage } } = head;

    if (!botByName) {
        return <Redirect to='/' />;
    }

    const pageTitle = title.text +' '+botByName.content_1;
    const metaDescriptionTitle = metaTitle.text +' '+botByName.content_1;
    const metaDescriptionText = metaDescription.text +' '+botByName.content_1;
    const metaImageSrc = `${serverUri}ogImage/bots`;

    return <BotContainer>
        <Helmet>
            {!!title && <title>{pageTitle}</title>}
            {!!metaTitle && <meta name='title' content={metaDescriptionTitle} />}
            {!!metaTitle && <meta name='og:title' content={metaDescriptionTitle} />}
            {!!metaImage && <meta name='og:image' content={metaImageSrc} />}
            {!!metaDescription && <meta name='description' content={metaDescriptionText} />}
            {!!metaDescription && <meta name='og:description' content={metaDescriptionText} />}
            {!!metaDescription && <meta name='twitter:description' content={metaDescriptionText} />}
        </Helmet>
        <RenderBot
            bot={botByName}
            reducedContent={reducedContent}
        />
    </BotContainer>;
};

export default Bot;